import React, { useContext, useEffect, useState } from "react";
import { useSnackbar } from "notistack";

import app, { firebase } from "../../configurations/firebase";
import { AuthContext } from "../AuthContext/AuthContext";

export const EmployeeContext = React.createContext({});

export const EmployeeProvider = ({ children }) => {
  const { profile } = useContext(AuthContext);

  const [employees, setEmployees] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const addEmployeeData = (dataObj) => {
    setLoading(true)
    app
      .firestore()
      .collection("users")
      .add({
        ...dataObj,
        createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
        createdBy: profile,
      })
      .then((docRef) => {
        console.log("Document written with ID: ", docRef.id);
        enqueueSnackbar("Document written", { variant: "success" });
        getEmployeeDataAll()
        setLoading(false)
      })
      .catch((e) => {
        console.error("Error adding document: ", e);
        enqueueSnackbar(e.message, { variant: "error" });
        setLoading(false)
      });
  };

  const setEmployeeData = (dataId, dataObj) => {
    setLoading(true)
    console.log(dataId, dataObj);
    app
      .firestore()
      .collection("users")
      .doc(dataId)
      .set({
        ...dataObj,
        createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
        createdBy: profile,
      })
      .then(() => {
        console.log("Document written with ID: ", dataId);
        enqueueSnackbar("Document written", { variant: "success" });
        getEmployeeDataAll()
        setLoading(false)
      })
      .catch((e) => {
        console.error("Error adding document: ", e);
        enqueueSnackbar(e.message, { variant: "error" });
        setLoading(false)
      });
  };

  const updateEmployeeData = (dataId, dataObj) => {
    setLoading(true)
    app
      .firestore()
      .collection("users")
      .doc(dataId)
      .update({
        ...dataObj,
        modifiedAt: firebase.firestore.Timestamp.fromDate(new Date()),
        modifiedBy: profile,
      })
      .then(() => {
        console.log("Document successfully written!");
        enqueueSnackbar("Document successfully updated!", {
          variant: "success",
        });
        getEmployeeDataAll()
        setLoading(false)
      })
      .catch((e) => {
        console.error("Error writing document: ", e);
        enqueueSnackbar(e.message, { variant: "error" });
        setLoading(false)
      });
  };

  const deleteEmployeeData = (dataId) => {
    setLoading(false)
    app
      .firestore()
      .collection("users")
      .doc(dataId)
      .delete()
      .then(() => {
        console.log("Document successfully deleted!");
        enqueueSnackbar("Document successfully deleted!", {
          variant: "success",
        });
        getEmployeeDataAll()
        setLoading(false)
      })
      .catch((e) => {
        console.error("Error removing document: ", e);
        enqueueSnackbar(e.message, { variant: "error" });
        setLoading(false)
      });
  };

  const getEmployeeDataAll = () => {
    setLoading(true)
    app
      .firestore()
      .collection("users")
      .where('isAdmin', '==', false)
      .where('roles', 'array-contains', 'employee')
      .orderBy('createdAt', 'desc')
      .get()
      .then((querySnapshot) => {
        const arr = [];
        querySnapshot.forEach((doc) => {
          arr.push({ id: doc.id, ...doc.data() });
        });
        setEmployees(arr);
        setLoading(false)
      })
      .catch((e) => {
        console.log("Error", e);
        enqueueSnackbar(e.message, { variant: "error" });
        setLoading(false)
      });
  };


  useEffect(() => {
    getEmployeeDataAll()
  }, []);

  return (
    <EmployeeContext.Provider
      value={{
        loading,
        employees,
        selectedEmployee,
        setSelectedEmployee,
        getEmployeeDataAll,
        addEmployeeData,
        setEmployeeData,
        updateEmployeeData,
        deleteEmployeeData
      }}
    >
      {children}
    </EmployeeContext.Provider>
  );
};
